module.exports = __webpack_public_path__ + "static/media/veracruzimg.ace80557.jpg";